class URLConstant {
  // Manual environment flags: toggle PROD true/false as needed
  PROD = false; // set true for production, false for dev
  DEV = true; // optional mirror flag
  DEMO = true; // set true for demo builds; sed'd per branch in CI

  // Base hosts
  url_prod = "https://glydegateway.com";
  // url_dev = "https://staging.glydegateway.com";
  url_dev = "https://dev.glydegateway.com";
  // url_dev = "http://localhost:3000";
  url_demo = "https://api.demo.cassionova.com";

  // Final base URL for API
  get url(): string {
    return this.DEMO ? this.url_demo : this.PROD ? this.url_prod : this.url_dev;
  }

  get environment(): "PRODUCTION" | "TEST" {
    return this.PROD ? "PRODUCTION" : "TEST";
  }

  // Grouped endpoints used by this app (preorder APIs)
  get PREORDER() {
    return {
      BASE: `${this.url}/preorder`,
      generateOTP: (reservationId: string) =>
        `${this.url}/preorder/generateOTP/${encodeURIComponent(reservationId)}`,
      verifyOTP: `${this.url}/preorder/verifyOTP`,
      updateOrder: (reservationId: string) =>
        `${this.url}/preorder/updateOrder/${encodeURIComponent(reservationId)}`,
      editOrder: (reservationId: string) =>
        `${this.url}/preorder/editOrder/${encodeURIComponent(reservationId)}`,
      reservation: (reservationId: string) =>
        `${this.url}/preorder/reservation/${encodeURIComponent(reservationId)}`,
      reservationCalendar: (reservationId: string) =>
        `${this.url}/preorder/reservation/${encodeURIComponent(
          reservationId,
        )}/calendar.ics`,
      restaurant: (restaurantId: string, reservationId: string) =>
        `${this.url}/preorder/restaurant/${encodeURIComponent(
          restaurantId,
        )}/${encodeURIComponent(reservationId)}`,
      getModificationsByIds: `${this.url}/preorder/modifications/byIds`,
    } as const;
  }
}

const urls = new URLConstant();
export default urls;
